import React from 'react';
import MagnetButton from '../common/MagnetButton';

const Header = () => {
  const handleLogoClick = (event) => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleContactClick = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="absolute top-0 left-0 w-full p-8 md:p-12 flex justify-between items-center z-50 pointer-events-none">
      <a
        href="#home"
        onClick={handleLogoClick}
        className="pointer-events-auto text-white font-black text-3xl tracking-tighter mix-blend-difference hover:opacity-70 transition-opacity select-none cursor-pointer"
        style={{ fontFamily: 'Manrope, sans-serif' }}
      >
        DB.
      </a>

      <MagnetButton
        onClick={handleContactClick}
        className="pointer-events-auto group relative hidden md:flex items-center justify-center px-6 py-3 rounded-full border border-white/20 text-white hover:bg-white hover:text-black transition-colors duration-300 overflow-hidden"
      >
        <span className="relative z-10 text-sm font-medium uppercase tracking-widest">
          Kontakt
        </span>
      </MagnetButton>
    </div>
  );
};

export default Header;